import React, { useContext } from 'react'
import styles from './WhatsAppButton.module.css'
import WidgetContext from '../context/widgetContext'
import {WhatsappContainer} from '../../../theme/theme'
import config from "../../../config/enviroment";
import "external-svg-loader";
import WhatsAppIcon from '../WhatsAppIcon.svg'
import CloseWhatsapp from '../closeWhatsapp.svg'

export default function WhatsAppButton({show, bottom}) {
  const { handleOpen, isOpen } = useContext(WidgetContext)

  return (
    <div className={styles.root} onClick={handleOpen}>
        <WhatsappContainer show={show} open={isOpen} bottom={bottom}>
            {
                isOpen ?
                <svg data-src={CloseWhatsapp} /> :
                   <svg data-src={WhatsAppIcon} /> 
            }
        </WhatsappContainer>
    </div>
  )
}
